import React from 'react';

const DummyPage = () => {
    return (
        <div className="container mt-5 p-3 page-section ">
            <div className='minHight'>
            <div className="row p-4 mt-5 ">
                <div className="col-12">
                    <h1 className="text-muted">Dummy Page Heading</h1>
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-md-6 mb-4">
                    <h2 className="h5">Section 1</h2>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus lacinia odio vitae vestibulum vestibulum. Cras venenatis euismod malesuada. Nullam ac erat ut erat auctor gravida. Nam fringilla magna sed neque euismod, ac facilisis lorem vehicula.
                    </p>
                </div>
                <div className="col-md-6 mb-4">
                    <h2 className="h5">Section 2</h2>
                    <p>
                        Praesent euismod nisi eget velit sollicitudin, sed hendrerit massa tempor. In hac habitasse platea dictumst. Morbi consequat quam eu feugiat ullamcorper. Nulla facilisi. Donec lacinia finibus odio, nec interdum augue. Sed fringilla volutpat ipsum, nec cursus dolor.
                    </p>
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-12">
                    <h2 className="h5">Section 3</h2>
                    <p>
                        Suspendisse potenti. Nullam id dolor lacus. Nulla facilisi. Pellentesque eget quam vel erat tristique ullamcorper. Vivamus auctor, erat a varius congue, velit elit vestibulum est, a aliquet enim lorem quis turpis. Donec at neque ut lectus efficitur posuere in eu libero.
                    </p>
                </div>
            </div>
            </div>
        </div>
    );
};

export default DummyPage;
